import React from "react"

function EndingText() {
    return(
        <h1 id="endText">LARRY MAXWELL WILL RETURN...</h1>
    )
} 

export default EndingText